import { AppState, ViewMode } from '../types';
import {
  SET_VEHICLES,
  TOGGLE_CAMERA,
  SEARCH,
  CHANGE_VIEW_MODE,
  TOGGLE_COLLAPSE,
  AppActionTypes
} from '../types/actions';

const initialState: AppState = {
  vehicles: new Map(),
  cameras: new Map(),
  selected: new Map(),
  searchValue: '',
  viewMode: [ViewMode.active],
  leftPanelCollapsed: false,
  isLoaded: false
}

export const appReducer = ( state = initialState, action: AppActionTypes ): AppState => {
  switch ( action.type ) {
    case SET_VEHICLES:
      const { vehicles, cameras } = action.payload;
      for ( const vehicle of vehicles ) {
        state.vehicles.set( vehicle.id, vehicle );
      }
      for ( const camera of cameras ) {
        const {vehicleId, id, channel} = camera;
        state.cameras.set( `${vehicleId}-${id}-${channel}`, camera );
      }
      return {...state, isLoaded: true};
    case TOGGLE_CAMERA:
      const { camera, toggleTo } = action.payload;
      const { vehicleId, id, channel } = camera;
      const key = `${vehicleId}-${id}-${channel}`;
      if ( toggleTo && !state.selected.has( key ) ) {
        state.selected.set( key, camera );
      } else if ( !toggleTo && state.selected.has( key ) ) {
        state.selected.delete( key );
      }
      return {...state};
    case SEARCH:
      const { searchValue } = action.payload;
      state.searchValue = searchValue;
      return {...state};
    case CHANGE_VIEW_MODE:
      const { viewMode } = action.payload;
      console.warn( viewMode );
      if ( state.viewMode.includes( viewMode ) ) {
        state.viewMode = state.viewMode.filter( v => v !== viewMode );
      } else {
        state.viewMode.push( viewMode );
      }
      return {...state};
    case TOGGLE_COLLAPSE:
      const {leftPanelCollapsed} = action.payload;
      state.leftPanelCollapsed = leftPanelCollapsed;
      return {...state};
    default:
      if ( (action as any).type !== '@@INIT' ) {
        console.error( 'Action is not recognized by an appReducer:', action );
      }
      return {...state};
  }
}
